import { useSyncExternalStore } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { QUICK_PICKUPS } from '../data/quickPickupLocations';

// Delt leverandørliste (settings/quickPickups): én Firestore-lytter for hele appen så lenge noen bruker den.
let locations = QUICK_PICKUPS;
let unsubscribe = null;
const listeners = new Set();

function emit(next) {
  locations = next;
  listeners.forEach((l) => l());
}

function start() {
  unsubscribe = onSnapshot(
    doc(db, 'settings', 'quickPickups'),
    (snap) => {
      const data = snap.data();
      emit(data?.locations?.length > 0 ? data.locations : QUICK_PICKUPS);
    },
    () => emit(QUICK_PICKUPS),
  );
}

function subscribe(listener) {
  listeners.add(listener);
  if (listeners.size === 1) start();
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && unsubscribe) { unsubscribe(); unsubscribe = null; }
  };
}

export const useSuppliers = () => useSyncExternalStore(subscribe, () => locations);
